import { ref } from 'vue';
import { createSharedComposable, reactify } from '@vueuse/core';

// Temporary, in-memory card thumbnails keyed by file/video key. Bridges the gap
// between "item just uploaded" and "server thumbnail ready" (Stream processing
// can take minutes-to-hours). Not persisted — after a reload the real thumbnail
// exists, so a fresh session simply starts empty.
export const useUploadPreviews = createSharedComposable(() => {
    const previews = ref({}); // key -> objectURL | dataURL

    const set = (key, url) => {
        if (!key || !url) return;
        previews.value = { ...previews.value, [key]: url };
    };

    const remove = (key) => {
        const url = previews.value[key];
        if (!url) return;
        if (url.startsWith('blob:')) URL.revokeObjectURL(url);
        const next = { ...previews.value };
        delete next[key];
        previews.value = next;
    };

    const previewOf = reactify((key) => previews.value[key] ?? null);

    return { set, remove, previewOf };
});
